<template>
    <div>
        <b-navbar type="light" toggleable="lg" class="shadow-sm module-navbar">
            <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
            <b-collapse id="nav_dropdown_collapse" is-nav>
                <b-navbar-nav
                    v-if="
                        profile.currentView === constant.PROFILE &&
                        profile.mode === constant.VIEW
                    "
                >
                    <template
                        v-if="(_hasAccess('billing.invoice.update') && invoiceDetails)"
                    >
                        <b-nav-item v-if="isLoadingTopMenu">
                            <i class="cus-hourglass"></i>Loading
                        </b-nav-item>
                        <b-nav-item
                            key="POSTINVOICE"
                            v-else-if="( isBusinessActorActive(invoiceDetails) && invoiceDetails.status == BILLINGS.INVOICE.TYPE_REOPENED && _hasAccess('billing.invoice.add.status'))"
                            @click="postInvoice()"
                        >
                            <i class="cus-disk"></i>Post Invoice
                        </b-nav-item>
                        <b-nav-item
                            :disabled="isHasUsersChooseInvoice"
                            key="EDITINVOICE"
                            @click="
                                toggleProfileMode(constant.EDIT, invoiceDetails)
                            "
                            v-else-if="
                                (!isPaid(invoiceDetails) ||
                                    (_hasAccess('billing.invoice.add.status') &&
                                        invoiceDetails.status !=
                                            BILLINGS.INVOICE.TYPE_CLOSED)) &&
                                isBusinessActorActive(invoiceDetails)
                            "
                        >
                            <i class="cus-page-white-edit"></i>Edit Invoice
                        </b-nav-item>
                    </template>
                    <template
                        v-if="
                            invoiceDetails &&
                            invoiceDetails.status !=
                                BILLINGS.INVOICE.TYPE_REOPENED &&
                            (_hasAccess('billing.invoice.email') ||
                                _hasAccess('billing.invoice.print') ||
                                (_hasAccess('billing.invoice.sms') &&
                                    (_isExtensionEnabled('SMS') ||
                                        _isExtensionEnabled(
                                            '2_WAY_MESSAGING'
                                        ))))
                        "
                    >
                        <b-nav-item-dropdown>
                            <template slot="button-content">
                                <spinner v-if="isLoadingIcon.export" />
                                <i v-else class="cus-page-attach"></i>
                                Export
                            </template>
                            <b-dropdown-item
                                v-if="_hasAccess('billing.invoice.email')"
                                @click="openInvoiceEmailModal()"
                            >
                                <i class="cus-email"></i>Email Invoice
                            </b-dropdown-item>
                            <b-dropdown-item
                                v-if="
                                    _hasAccess('billing.invoice.sms') &&
                                    (_isExtensionEnabled('SMS') ||
                                        _isExtensionEnabled('2_WAY_MESSAGING'))
                                "
                                @click="openInvoiceSMSModal()"
                            >
                                <i class="cus-phone"></i>Text (SMS) Invoice
                            </b-dropdown-item>
                            <b-dropdown-item
                                v-if="_hasAccess('billing.invoice.print')"
                                @click="generatePrintPdf()"
                            >
                                <i class="cus-printer"></i>Print Invoice
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                    </template>
                    <template
                        v-if="
                            invoiceDetails &&
                            _hasAccess('setting.discount.apply') &&
                            !isPaid(invoiceDetails) &&
                            isBusinessActorActive(invoiceDetails) &&
                            invoiceDetails.status !=
                                BILLINGS.INVOICE.TYPE_REOPENED
                        "
                    >
                        <b-nav-item
                            key="APPLYDISCOUNT"
                            v-if="invoiceDetails.hide_apply_disc != 'hide'"
                            @click="openDiscountModal()"
                            :disabled="isHasUsersChooseInvoice"
                        >
                            <i class="cus-tag-blue-add"></i>Apply Discount
                        </b-nav-item>
                        <b-nav-item
                            key="REMOVEDISCOUNT"
                            v-if="invoiceDetails.hide_remove_disc != 'hide'"
                            @click="openRemoveDiscountModal()"
                            :disabled="isHasUsersChooseInvoice"
                        >
                            <i class="cus-tag-blue-delete"></i>Remove Discount
                        </b-nav-item>
                    </template>
                    <template
                        v-if="
                            invoiceDetails &&
                            invoiceDetails.status !=
                                BILLINGS.INVOICE.TYPE_REOPENED
                        "
                    >
                        <DropdownAppointmentStatus
                            v-if="invoiceDetails.appointment_count == 1"
                            @reload-page="reloadPage"
                            :invoiceId="invoiceId"
                        ></DropdownAppointmentStatus>

                        <b-nav-item
                            key="WRITEOFF"
                            v-if="
                                invoiceDetails &&
                                _hasAccess('billing.writeoff.create') &&
                                invoiceDetails.status !=
                                    BILLINGS.INVOICE.TYPE_CLOSED &&
                                invoiceDetails.balance > 0 &&
                                isBusinessActorActive(invoiceDetails)
                            "
                            @click="showEditModal(invoiceDetails)"
                            :disabled="isHasUsersChooseInvoice"
                        >
                            <i class="cus-page-white-put"></i>Write Off
                        </b-nav-item>
                        <!-- TODO: totalItems is missing from API  -->
                        <!--  v-if="
                        invoiceDetails && 
                        _hasAccess('billing.invoice.mark.paid') &&
                        (!isPaid(invoiceDetails) &&
                        invoiceDetails.balance == 0) &&
                        (invoiceDetails.totalItems > 0 && isBusinessActorActive(invoiceDetails))
                        " -->
                        <b-nav-item
                            v-if="
                                invoiceDetails &&
                                _hasAccess('billing.invoice.mark.paid') &&
                                !isPaid(invoiceDetails) &&
                                isBusinessActorActive(invoiceDetails) &&
                                invoiceDetails.amount == 0 &&
                                getItemCount()
                            "
                            @click="markAsPaid"
                            key="MARKASPAID"
                            :disabled="isHasUsersChooseInvoice"
                        >
                            <spinner v-if="isLoadingIcon.markaspaid" />
                            <i class="cus-accept" v-else></i>
                            Mark As Paid
                        </b-nav-item>
                        <b-nav-item
                            key="DELETEITEM"
                            @click="openInvoiceDeleteModal(invoiceDetails)"
                            v-if="
                                invoiceDetails &&
                                _hasAccess('billing.invoice.delete') &&
                                !isPaid(invoiceDetails)
                            "
                            :disabled="isHasUsersChooseInvoice"
                        >
                            <i class="cus-delete"></i>Delete Invoice
                        </b-nav-item>
                    </template>
                </b-navbar-nav>

                <b-navbar-nav
                    v-else-if="
                        profile.currentView === constant.PROFILE &&
                        profile.mode === constant.EDIT &&
                        profile.isSaving
                    "
                >
                    <b-nav-item>
                        Saving...
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav
                    v-else-if="
                        profile.currentView === constant.PROFILE &&
                        profile.mode === constant.EDIT &&
                        profile.isSaving === false
                    "
                >
                    <b-nav-item
                        @click="savingCheckForm"
                        key="EDITSAVE"
                        :disabled="isHasUsersChooseInvoice"
                    >
                        <i class="cus-disk"></i>Save Invoice
                    </b-nav-item>
                    <b-nav-item
                        @click="() => resetProfileState(false)"
                        key="EDITCANCEL"
                    >
                        <i class="cus-cancel"></i>Cancel
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
            <b-navbar-nav class="ml-auto">
                <!-- will refactor later -->
                <b-nav-form
                    @click="$refs['select-billing'].focus()"
                    @contextmenu="rightClickHandler"
                    class="ml-auto"
                >
                    <vet-select-billing
                        ref="select-billing"
                        :key="'search' + searchItemKey"
                        :focus-onload="true"
                        class="mr-sm-2 w-100 search nav-search show-actions"
                    />
                </b-nav-form>
            </b-navbar-nav>
        </b-navbar>
        <router-view
            ref="routerView"
            :profileMode="profile.mode"
            :invoiceDetails="invoiceDetails"
            @saved="saved"
            @redirect-to-dashboard="redirectToDashoard"
            @set-invoice-details="setInvoiceDetails"
            @saving-confirmation="showSavingConfirmation"
        ></router-view>

        <!-- Billing Write off -->
        <writeoff-save-modal
            ref="writeoffSaveModal"
            modal-ref="modal-save-writeoff"
            :write-off="selectedParams"
            :invoicePage="{ new: true }"
            @reload="reloadPage"
        />

        <invoice-email-modal
            modal-ref="invoice-email-modal"
            ref="invoice-email-modal"
            v-if="invoiceDetails"
            :invoice="invoiceDetails"
            :client="clientDetails"
        />

        <apply-discount-modal
            v-if="invoiceId"
            ref="apply-discount-modal"
            modal-ref="apply-discount-modal"
            :invoice-id="invoiceId"
            @reload="reloadPage"
        />

        <remove-discount-modal
            v-if="invoiceId"
            ref="remove-discount-modal"
            modal-ref="remove-discount-modal"
            :invoice-id="invoiceId"
            @reload="reloadPage"
        />

        <invoice-delete-modal
            modal-ref="invoice-delete-modal"
            ref="invoice-delete-modal"
            :invoice="selectedInvoice"
            @reload="redirectToDashoard()"
        />

        <modal-save-confirm-invoice
            modal-id="modal-save-confirm-invoice"
            ref="modal-save-confirm-invoice"
            modalRef="modal-save-confirm-invoice"
            @proceed="proceedSaveEditInvoice"
        />

        <modal-post-invoice
            modal-id="modal-post-invoice"
            ref="modalPostInvoice"
            @reload="reloadPage"
        />

        <invoice-send-SMS-modal ref="modal-invoice-send-sms" />

        <exportPrintPdf
            ref="exportPrintPdf"
            v-if="selectedInvoice"
            :invoice="selectedInvoice"
            @show-loading="
                isLoading => {
                    isLoadingIcon.export = isLoading;
                }
            "
        />
    </div>
</template>

<script>
import unsavePrompt from "@/mixins/unsave-prompt.js";
import VetSelectBilling from "@/module/commons/vet-select-billing";
import BillingInvoiceServices from "@/services/billing/billing-invoice";
import WriteoffSaveModal from "@/components/billing-writeoffs/writeoff-save-modal";
import ApplyDiscountModal from "@/components/invoice/invoice-apply-discount-modal";
import RemoveDiscountModal from "@/components/invoice/invoice-remove-discount-modal";
import ModalSaveConfirmInvoice from "@/components/invoice/invoice-save-confirm-modal.vue";
import DropdownAppointmentStatus from "@/components/appointments/appointment-status-dropdown.vue";
import ModalPostInvoice from "@/components/invoice/invoice-post-invoice.vue";
import InvoiceGeneralService from "@/services/invoice/invoice-general";
import ScheduleHelper from "@/module/schedule/helper";
import invoiceHelper from "@/mixins/invoice";
import { isEmpty } from "lodash";
import BILLINGS from "@/constants/billings";

const PROFILE = "invoice";
const VIEW = "VIEW";
const EDIT = "EDIT";

/**
 * @name InvoiceIndex
 * Apply key to the b-nav-item with @click to prevent the button run click event when changing page
 * @see apps/application/views/staff/billing/invoice/writeoff/create_update.php
 * @see apps/application/views/staff/billing/invoice/invoice/view.php
 * @see apps/application/views/staff/billing/invoice/invoice/detail.php
 * @see apps/application/views/staff/billing/invoice/invoice/remove.php
 * @see apps/application/views/staff/billing/invoice/invoice/navbar.php
 */
export default {
    mixins: [unsavePrompt, ScheduleHelper, invoiceHelper],
    components: {
        VetSelectBilling,
        WriteoffSaveModal,
        ApplyDiscountModal,
        RemoveDiscountModal,
        ModalPostInvoice,
        ModalSaveConfirmInvoice,
        DropdownAppointmentStatus,
        Spinner: () => import("@/components/elements/spinner"),
        InvoiceEmailModal: () =>
            import("@/components/client-invoices/invoice-email-modal"),
        InvoiceSendSMSModal: () =>
            import("@/components/invoice-sms/modal-invoice-send-sms"),
        InvoiceDeleteModal: () =>
            import("@/components/client-invoices/invoice-delete-modal"),
        ExportPrintPdf: () =>
            import("@/components/billing-export/export-print-pdf.vue")
    },
    props: {},
    data() {
        return {
            BILLINGS,
            searchInvoiceKey: 0,
            constant: {
                PROFILE,
                VIEW,
                EDIT
            },
            profile: {
                currentView: "",
                mode: VIEW,
                isSaving: false
            },
            invoiceDetails: null,
            searchItemKey: 0,
            searchItem: null,
            usesCount: 0,
            isLoadingIcon: {
                markaspaid: false,
                export: false
            },
            selectedParams: null,
            selectedInvoice: {},
            savingConfirmation: false,
            isLoadingTopMenu: false
        };
    },
    computed: {
        invoiceId() {
            return this.invoiceDetails ? this.invoiceDetails.id : null;
        },
        clientDetails() {
            return this.$store.getters["client/clientDetails"];
        },
        isHasUsersChooseInvoice() {
            return this.invoiceId
                ? !isEmpty(
                      this.$store.getters["billing/findUserChooseInvoice"](
                          this.invoiceId
                      )
                  )
                : false;
        }
    },
    watch: {
        async $route(to) {
            this.toggleView(to.name);
            await this.$nextTick();
            this.resetProfileState();
        },
        "$route.name"() {
            this.searchInvoiceKey++;
        },
        invoiceDetails(details) {
            if (!details.appointment) {
                return;
            }
        }
    },
    mounted() {
        const currentRoute = this.$router.history.current.name;
        this.toggleView(currentRoute);
        this._getStatus().then(statuses => {
            this.$store.commit(
                "status",
                statuses.map(status => ({
                    ...status,
                    icon: this.statusClass(status.id)
                }))
            );
        });
    },
    methods: {
        async openInvoiceDeleteModal(invoice) {
            let proceed = await this.checkInvoiceStatus(this.invoiceId);
            if (!proceed) {
                this.reloadPage();
                return;
            }

            this.selectedInvoice = invoice;

            if (invoice.totalItems > 0) {
                let date = this._fromDateCarbon(invoice.start).toFormat("X");

                this.$store.dispatch("checkBillingLock", {
                    date,
                    onProceed: () => this.$refs["invoice-delete-modal"].open(),
                    onError: message => this._message(message, "danger")
                });
            } else {
                this.$refs["invoice-delete-modal"].open();
            }
        },
        isPaid(invoice) {
            return (
                (invoice.status == BILLINGS.INVOICE.TYPE_PAID &&
                    invoice.balance == 0) ||
                invoice.status == BILLINGS.INVOICE.TYPE_WRITEOFF ||
                invoice.status == BILLINGS.INVOICE.TYPE_CLOSED
            );
        },
        async markAsPaid() {
            let proceed = await this.checkInvoiceStatus(this.invoiceId);
            if (!proceed) {
                this.reloadPage();
                return;
            }

            let self = this;
            self.isLoadingIcon.markaspaid = true;
            BillingInvoiceServices.markAsPaid(self.invoiceDetails.id)
                .then(response => {
                    if (response && response.code === 200) {
                        self._message(response.message);
                        this.reloadPage();
                    } else if (response && response.code == 400) {
                        throw response.message;
                    } else {
                        throw "Error : Unable mark as paid";
                    }
                })
                .catch(error => {
                    self._message(error, "danger");
                })
                .finally(() => {
                    self.isLoadingIcon.markaspaid = false;
                });
        },
        async openInvoiceSMSModal() {
            let proceed = !this.isPaid(this.invoiceDetails)
                ? await this.checkInvoiceStatus(this.invoiceId)
                : true;
            if (!proceed) {
                this.reloadPage();
                return;
            }

            this.$refs["modal-invoice-send-sms"].open(this.invoiceDetails.id);
        },
        async openInvoiceEmailModal() {
            let proceed = !this.isPaid(this.invoiceDetails)
                ? await this.checkInvoiceStatus(this.invoiceId)
                : true;
            if (!proceed) {
                this.reloadPage();
                return;
            }

            await this.$store.dispatch("client/getClientDetails", {
                id: this.invoiceDetails.client_id
            });

            this.$refs["invoice-email-modal"].open();
        },
        async openDiscountModal() {
            let proceed = await this.checkInvoiceStatus(this.invoiceId);
            if (!proceed) {
                this.reloadPage();
                return;
            }
            this.$refs["apply-discount-modal"].open();
        },
        async openRemoveDiscountModal() {
            let proceed = await this.checkInvoiceStatus(this.invoiceId);
            if (!proceed) {
                this.reloadPage();
                return;
            }
            this.$refs["remove-discount-modal"].open();
        },
        showSavingConfirmation(status) {
            this.savingConfirmation = status;
        },
        isBusinessActorActive(invoice) {
            return (
                invoice.client &&
                invoice.client.single_business_actor &&
                invoice.client.single_business_actor.isactive
            );
        },
        goToAppPage() {
            window.open(
                `${process.env.CI_APPS}billing/invoice/view/${this.invoiceDetails.encoded_id}`,
                "_blank"
            );
        },
        redirectToDashoard() {
            this.$store.commit("billing/setDirty", false);
            this.$router.replace("/billing/dashboard");
        },
        setInvoiceDetails(details) {
            this.invoiceDetails = details;
        },
        toggleView(routeName) {
            // NOTE: check for direct JUMP url
            if (routeName == "direct-url-billing-invoice-profile") {
                this.profile.currentView = "invoice";
            } else {
                this.profile.currentView = routeName;
            }
        },
        async toggleProfileMode(value, invoice) {
            let proceed = !(
                invoice.status == BILLINGS.INVOICE.TYPE_PAID ||
                invoice.status == BILLINGS.INVOICE.TYPE_WRITEOFF ||
                invoice.status == BILLINGS.INVOICE.TYPE_CLOSED
            )
                ? await this.checkInvoiceStatus(this.invoiceId)
                : true;
            if (!proceed) {
                this.reloadPage();
                return;
            }

            this.profile.mode = value;
            if (value == EDIT) {
                this.$refs.routerView.resetTab();
            }
        },
        /////////////////
        // FLOW SAVING //
        /////////////////
        /**
         * @method savingCheckForm
         * @description Flow to save invoice edit
         * savingCheckForm(invoice.vue) -> checkFormValid(invoice.vue) -> isValid(invoice/invoice-update.vue) : Boolean
         * savingConfirmation -> open modal warning save for write off status only
         * proceedSaveEditItem
         */
        async savingCheckForm() {
            const isFormValid = await this.$refs.routerView.savingCheckFormValid();
            if (!isFormValid) {
                this.cancelSaved();
                return;
            }

            if (this.savingConfirmation) {
                this.$refs["modal-save-confirm-invoice"].open();
            } else {
                this.proceedSaveEditInvoice();
            }
        },
        ////////////////////////
        // FLOW SAVING - EDIT //
        ////////////////////////
        /**
         * @method proceedSaveEditInvoice
         * @description Before proceed saving, the flow must check if write off status to other status.
         */
        proceedSaveEditInvoice() {
            this.profile.isSaving = true;
            this.$refs.routerView.savingEditInvoice();
        },
        /**
         * @method cancelSaved
         * @description Cancel saving and return to edit mode form
         */
        cancelSaved() {
            this.profile.isSaving = false;
            this.$store.commit("billing/setDirty", false);
        },
        /**
         * @method saved
         * @description Form has been saved
         */
        saved(result = {}) {
            this.profile.isSaving = false;
            if (result.success) {
                this.profile.mode = VIEW;
            }
        },
        /**
         * @method resetProfileState
         * @description Reset profile mode used when change invoice profile and cancel edit
         */
        resetProfileState(clearDetails = true) {
            if (clearDetails) {
                this.invoiceDetails = null;
            }
            this.profile.mode = VIEW;
            this.$store.commit("billing/setDirty", false);
            if (this.profile.currentView == this.constant.PROFILE) {
                this.$refs.routerView.resetTab();
            }
        },
        confirmDelete() {
            this.$refs.modalDeleteItem.open(this.invoiceDetails.id);
        },
        rightClickHandler(e) {
            if (e.which === 3) {
                this.$refs["select-billing"].focus();
            }
        },
        async generatePrintPdf() {
            let proceed = !this.isPaid(this.invoiceDetails)
                ? await this.checkInvoiceStatus(this.invoiceId)
                : true;
            if (!proceed) {
                this.reloadPage();
                return;
            }

            this.selectedInvoice = this.invoiceDetails;
            await this.$nextTick();
            this.$refs.exportPrintPdf.init();
        },
        async showEditModal(invoice) {
            let proceed = await this.checkInvoiceStatus(this.invoiceId);
            if (!proceed) {
                this.reloadPage();
                return;
            }

            let params = {
                client: invoice.client,
                amount: invoice.balance_amount,
                invoice_id: invoice.id
            };
            this.selectedParams = params;
            this.$refs.writeoffSaveModal.open();
        },
        reloadPage() {
            this.$refs.routerView.reloadPage("tabItems");
        },
        async postInvoice() {
            this.isLoadingTopMenu = true;
            document.body.style.cursor = "wait";

            let proceed = await this.checkInvoiceStatus(this.invoiceId);
            if (!proceed) {
                this.isLoadingTopMenu = false;
                document.body.style.cursor = "";
                this.reloadPage();
                return;
            }

            // check if there is overpayment
            this.profile.isSaving = true;

            try {
                let res = await InvoiceGeneralService.prePostInvoice({
                    invoice_id: this.invoiceDetails.id
                });

                if (res?.response?.code === 400) {
                    throw res.response.message;
                }

                let response = res?.response?.response ?? {};

                if (Number(response.status) === 0) {
                    this.reloadPage();
                } else {
                    if (
                        response.message == "Error saving data" ||
                        response.length == 0 ||
                        response.code === 400
                    ) {
                        throw response.message;
                    }

                    this.$refs.modalPostInvoice.open(response);
                }
            } catch (error) {
                this._message(error || "Error saving data", "danger");
            } finally {
                this.profile.isSaving = false;
                this.isLoadingTopMenu = false;
                document.body.style.cursor = "";
            }
        },
        getItemCount() {
            return (
                this.invoiceDetails.active_invoice_items.length > 0 ||
                this.$refs.routerView.tabCount.declined_count
            );
        }
    }
};
</script>
